import React, { useEffect, useRef } from 'react';

interface FileUploadProps {
    onFileChange: (file: File | null) => void;
    reset: boolean; // Add reset prop
}

const FileUpload: React.FC<FileUploadProps> = ({ onFileChange, reset }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (reset && fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    }, [reset]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        onFileChange(file);
    };

    return (
        <input
            type="file"
            ref={fileInputRef}
            onChange={handleChange}
        />
    );
};

export default FileUpload;